import CareLevelMailForm from './CareLevelMailForm';

export default CareLevelMailForm;
